import store from '../../store';
import Errors from '../../Errors';
import CartHelpersMixin from '../../mixins/CartHelpersMixin';
import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';
import {
    trans
} from '../../functions';
import Index  from './../cart/Index';
import moment from 'moment';
import 'moment-timezone';
import 'moment-business-days';
import Datepicker from 'vuejs-datepicker';
import {sv} from 'vuejs-datepicker/dist/locale'

export default {
    mixins: [
        CartHelpersMixin,
        ProductHelpersMixin,
        Index
    ],
    components: { Datepicker },

    props: [
        'customerEmail', 
        'customerPhone', 
        'customerFirstName', 
        'customerLastName', 
        'gateways', 
        'defaultAddress', 
        'addresses', 
        'countries', 
        'shippingByDistance', 
        'time', 
        'dayShippingFuneral', 
        'dayShippingNormal', 
        'timeReceiveAfter', 
        'holidayDelivery', 
        'dayOffDelivery', 
        'timeDelivery', 
        'timeDeliveryWeekend', 
        'deliveryLimit', 
        'deliveryMorningFrom',
        'deliveryMorningTo',
        'deliveryAfternoonFrom',
        'deliveryAfternoonTo',
        'deliveryWeekendMorningFrom',
        'deliveryWeekendAfternoonFrom',
        'deliveryWeekendMorningTo',
        'deliveryWeekendAfternoonTo',
        'openStoreTime', 
        'closeStoreTime',
        'openStoreTimeWeekend', 
        'closeStoreTimeWeekend',
        'shippingBegravningTimeFrom',
        'shippingBegravningTimeTo',
        'shippingBegravningTimePeriod',

    ],

    data() {
        return {
            sv: sv,
            form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                customer_first_name: this.customerFirstName,
                customer_last_name: this.customerLastName,
                billing: {
                    first_name: '',
                    last_name: '',
                    phone: '',
                    errors: {}
                },
                multipleAddresses: [],
                costShippingByDistance: this.shippingByDistance.cost_in_inside_city_center,
                costExtraShippingDistance: 0,
                fulllAddress: null,
                errorAddress: null,
                delivery_type: 0
            },
            states: {
                billing: {},
                shipping: {},
            },
            placingOrder: false,
            errors: new Errors(),
            showCheckout: false,
            isDelivery: false,
            showAuth: null,
            showGateway: 'pay_at_the_store',
            isCheckOne: false,
            isCheckTwo: false,
            isCheckThree: false,
            isCheckFour: false,
            showModal: false,
            checkoutUrl: null,
            hiddenCheckout: true,
            date: null,
            showFrom: true,
            disabledTwo: true,
            disabledThree: true,
            disabledFour: true,
            step: 1,
            addressArr: [],
            countAccordion: 0,
            productOptions: [],
            remainProducts: [],
            selectedProduct: null,
            maxQuantity: 10, 
            qty: 10,
            keyItem: null,
            isShowAddProd: true,
            hoursRangeStore: [],
            minutesRangeStore: [0, 15, 30, 45], 
            hoursRange: [],
            minutesRange: [0, 15, 30, 45], 
            isAddProdButton: true,
            feeMultiAddress: 0,
            disabledDates: {
                to: null,
                dates: [],
                customPredictor: () => {}
            },
            disabledDatesMulti: {
                to: null,
                dates: [],
                customPredictor: () => {}
            },
            timeOptions: [],
            timeOpen: null,
            timeClose: null,
            timeReceiver: null,
        };
    },

    computed: {
        hasAddress() {
            return Object.keys(this.addresses).length !== 0;
        },

        paymentPayAtTheStoreLabel() {
            return this.gateways['pay_at_the_store'].label;
        },
    },

    watch: {
        // 'form.billing.city': function (newCity) {
        //     if (newCity) {
        //         this.addTaxes();
        //         this.chargeShippingCode();
        //     }
        // },

        'form.billing.deceased_date': function (date) {
             this.$set(this.form.billing, 'deceased_date', moment(date).format('YYYY-MM-DD'));
             this.$set(this.form.billing, 'date_shipping', moment(date).format('YYYY-MM-DD'));
         },

        'form.billing.date_shipping': function (date) {
            if(this.form.shipping_method == 'delivery') {
                this.checkTimeDelivery(this.form.billing.date_shipping);
                if(!this.form.is_special) {
                    if(!this.timeOptions.includes(this.form.billing.time_shipping)) {
                        this.$set(this.form.billing, 'time_shipping', this.timeOptions[0]); 
                    }
                }
            } else {
                if(date == moment().format('YYYY-MM-DD')) {
                    this.$set(this.form.billing, 'time_shipping', trans('cart::messages.after') + ' ' + this.timeReceiver);
                    this.$set(this.form.billing, 'date_note', trans('cart::messages.note_pickup') + ' ' + this.timeReceiver);
                } else {
                    // if(this.form.is_special) {
                    //     this.$set(this.form.billing, 'time_shipping', this.hoursRange.length > 0 ? this.hoursRange[0] : '');
                    // } else {
                    this.$set(this.form.billing, 'time_shipping', '');
                    // }
                    this.$set(this.form.billing, 'date_note', '');
                }
            }
            this.$set(this.form.billing, 'date_shipping', moment(date).format('YYYY-MM-DD'));
        },

        'form.terms_and_conditions': function () {
            this.errors.clear('terms_and_conditions');
        },
    },

    created() {
        this.$set(this.form, 'is_special', this.hasSpecialProduct);
        this.productOptions = Object.assign({}, this.cart.items);
        this.$set(this.form, 'delivery_type', 0);

        var auth = this.sessionGet('form-auth');
        this.showAuth = auth ? auth : 'login';
        if(auth == 'guest') {
            this.$set(this.form, 'shop_as', 'guest');
        } else {
            this.$set(this.form, 'shop_as', 'login');
        }

        this.init();

        this.$nextTick(() => {
            this.$set(this.form.billing, 'date_note', '');

            var shippingBreFrom = moment(this.shippingBegravningTimeFrom, 'h:mma').format('HH');
            var shippingBreTo = moment(this.shippingBegravningTimeTo, 'h:mma').format('HH');
            var time = moment(this.shippingBegravningTimeFrom, 'h:mma');
            this.hoursRange.push(moment(time).format('HH:mm'));

            for(var i = 0; i<= ((parseInt(shippingBreTo) - parseInt(shippingBreFrom)) * 2 - 1); i++) {
                time = time.add(this.shippingBegravningTimePeriod, 'minutes');
                this.hoursRange.push(moment(time).format('HH:mm'));
            }

            if(moment().isoWeekday() == 6 || moment().isoWeekday() == 7) {
                this.timeOpen = moment(this.openStoreTimeWeekend,'h:mma'),
                this.timeClose = moment(this.closeStoreTimeWeekend,'h:mma').subtract(this.timeReceiveAfter, 'hours');
            } else {
                this.timeOpen = moment(this.openStoreTime,'h:mma'),
                this.timeClose = moment(this.closeStoreTime,'h:mma').subtract(this.timeReceiveAfter, 'hours');
            }

            var currentTime =  moment(moment().tz('Europe/Stockholm').format('h:mma'), 'h:mma');

            if (this.timeOpen.isAfter(currentTime)) {
                this.timeReceiver = this.timeOpen.add(this.timeReceiveAfter, 'hours').format('HH:mm');
            } else {
                this.timeReceiver = moment().tz("Europe/Stockholm").add(this.timeReceiveAfter, 'hours').format('HH:mm');
            }

            let dayOffs = [];
            if(JSON.parse(this.dayOffDelivery)) {
                dayOffs = JSON.parse(this.dayOffDelivery).map(day => {
                    day = new Date(day);
                    return day;
                });
            }

            this.$set(this.disabledDates, 'dates', dayOffs);
            this.$set(this.disabledDatesMulti, 'dates', dayOffs);

            if (this.firstPaymentMethod) {
                this.changePaymentMethod(this.firstPaymentMethod);
            }
            this.$set(this.form, 'payment_method', 'pay_at_the_store');

            this.hasOptionBand;
            this.maxDate(this.form.billing, this.isSpecial);
        });
    },

    mounted() {},

    methods: {
        maxDate(model, condition) 
        {
            if(condition) {
                var momentBusinessDays = require("moment-business-days");

                if(this.isBand) {
                    this.date = moment(momentBusinessDays(moment().tz("Europe/Stockholm").format('YYYY-MM-DD'), 'YYYY-MM-DD').businessAdd(this.dayShippingFuneral)._d).format('YYYY-MM-DD');
                } else {
                    this.date = moment().tz("Europe/Stockholm").add(this.dayShippingFuneral, 'days').format('YYYY-MM-DD');
                }

                if(moment(this.date).isoWeekday() == 7) {
                    this.date = moment(this.date).add(1, 'days').format('YYYY-MM-DD');
                }
            } else {
                let currentTime = moment(moment().tz("Europe/Stockholm").format('h:mma'), 'h:mma');

                if(moment(currentTime, 'h:mma').isAfter(moment(this.time, 'h:mma'))) {
                    this.date = moment().add(this.dayShippingNormal, 'days').format('YYYY-MM-DD');
                } else {
                    if (this.timeOpen.isAfter(currentTime) || currentTime.isBetween(this.timeOpen, this.timeClose)) {
                        this.date = moment().format('YYYY-MM-DD');
                    } else {
                        this.date = moment().add(1, 'days').format('YYYY-MM-DD');
                    }

                    this.$set(model, 'time_shipping', trans('cart::messages.after') + ' ' + this.timeReceiver);
                    this.$set(model, 'date_note', trans('cart::messages.note_pickup') + ' ' + this.timeReceiver);
                }
            }

            this.disabledDates.dates.forEach(e => {
                if(moment(e).format('YYYY-MM-DD') == this.date) {
                    this.date = moment(e).add(1, 'days').format('YYYY-MM-DD');
                }
            });

            this.checkTimeDelivery(this.date);

            this.$set(model, 'date_shipping', this.date);
            this.$set(model, 'deceased_date', this.date);
            this.$set(this.disabledDates, 'to', new Date(this.date));
            this.$set(this.disabledDatesMulti, 'to', new Date(this.date));
        },

        checkTimeDelivery(date) 
        {
            this.timeOptions = [];
            let weekend = false;
            let morningTime = this.deliveryMorningFrom ? trans('nya::checkout.morning') + ' ( ' + this.deliveryMorningFrom + ' - ' + this.deliveryMorningTo  + ' )' : '';
            let afternoonTime = this.deliveryAfternoonFrom ? trans('nya::checkout.afternoon') + ' ( ' + this.deliveryAfternoonFrom + ' - ' + this.deliveryAfternoonTo  + ' )' : '';
            let morningWeekendTime = this.deliveryWeekendMorningFrom ? trans('nya::checkout.morning') + ' ( ' + this.deliveryWeekendMorningFrom + ' - ' + this.deliveryWeekendMorningTo  + ' )' : '';
            let afternoonWeekendTime = this.deliveryWeekendAfternoonFrom ? trans('nya::checkout.afternoon') + ' ( ' + this.deliveryWeekendAfternoonFrom + ' - ' + this.deliveryWeekendAfternoonTo  + ' )' : '';

            let currentTime = moment(moment().tz("Europe/Stockholm").format('h:mma'), 'h:mma');
            if(JSON.parse(this.holidayDelivery)) {
                if(JSON.parse(this.holidayDelivery).includes(date)) {
                    weekend = true;
                }
            }
            if(moment(date).isoWeekday() == 6 || moment(date).isoWeekday() == 7  || weekend) {
                if (date == moment().format('YYYY-MM-DD')) {
                    if(!moment(currentTime, 'h:mma').isAfter(moment(this.time, 'h:mma'))) {
                        if(afternoonWeekendTime) {
                            this.timeOptions = [afternoonWeekendTime];
                        }
                    }
                } else {
                    this.timeOptions = [];
                    if(date == moment().add(1, 'days').format('YYYY-MM-DD')) {
                        this.timeOptions.push(afternoonWeekendTime);
                    } else {
                        if(morningWeekendTime) {
                            this.timeOptions.push(morningWeekendTime);
                        }
    
                        if(afternoonWeekendTime) {
                            this.timeOptions.push(afternoonWeekendTime);
                        }
                    }

                }
            } else {
                if (date == moment().format('YYYY-MM-DD')) {
                    if(!moment(currentTime, 'h:mma').isAfter(moment(this.time, 'h:mma'))) {
                        if(afternoonTime) {
                            this.timeOptions = [afternoonTime];
                        }
                    }
                } else {
                    this.timeOptions = [];

                    if(date == moment().add(1, 'days').format('YYYY-MM-DD')) {
                        this.timeOptions.push(afternoonTime);
                    } else {
                        if(morningTime) {
                            this.timeOptions.push(morningTime);
                        }
    
                        if(afternoonTime) {
                            this.timeOptions.push(afternoonTime);
                        }
                    }
                }
            }
        },

        init() 
        {
            this.isShowAddProd = Object.keys(this.productOptions).length > 0 ? true : false;

            if(this.isShowAddProd) {
                this.keyItem = Object.keys(this.productOptions)[0];
                this.selectedProduct =  Object.assign({}, Object.values(this.productOptions)[0]);
                this.maxQuantity = Object.values(this.productOptions)[0].qty;
                this.qty = this.selectedProduct.qty;
            }
        },

        addAddress(name)
        {
            this.$set(this.disabledDates, 'customPredictor', function(date) {
                return false;
            });

            if(this.countAccordion > 0){
                var keys = [];
                if(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)].isDelivery) {
                    if(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)].is_special) {
                        keys = ['deceased_first_name', 'deceased_last_name', 'deceased_date', 'time_shipping', 'address', 'city'];
                    } else {
                        keys = ['first_name', 'last_name', 'phone', 'time_shipping', 'address', 'city'];
                    }
                } else {
                    if(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)].is_special) {
                        keys = ['date_shipping'];
                    } else {
                        keys = [];
                    }
                }

              this.checkValidationForm(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)], keys);

                if(Object.keys(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)].errors).length) {
                    this.$notify(trans('core::messages.the_given_data_was_invalid'));   
                    return;
                }
            }

            let timeShipping = '';
            let deceased_date = '';

            if(name) {
                this.isAddProdButton = false;

                if(this.date == moment().format('YYYY-MM-DD')) {
                    timeShipping = trans('cart::messages.after') + ' ' + this.timeReceiver;
                } else {
                    timeShipping = '';
                }

                deceased_date = '';
            } else {
                deceased_date = this.date;
            }

            this.addressArr.map(e => e.active = false);

            this.form.multipleAddresses.push(
                {
                    ['billing' + this.countAccordion]: {
                        products: [],
                        date_shipping: this.date,
                        time_shipping: timeShipping,
                        deceased_date: deceased_date,
                        is_special: false,
                        isDelivery: name ? 0 : 1,
                        fee: 0,
                        feeFormatted: '',
                        errors: {
                        },
                        date_note: this.date == moment().format('YYYY-MM-DD') ? trans('cart::messages.note_pickup') + ' ' + this.timeReceiver : ''
                    }
                }
            );

            var item = {
                'index': this.countAccordion, 
                'collapse': 'collapse'+this.countAccordion,
                'data_target': '#confirm-delete-'+this.countAccordion,
                'modal_id': 'confirm-delete-'+this.countAccordion,
                'collapseTarget': '#collapse'+this.countAccordion,
                'key': 'billing' + this.countAccordion,
                'model': 'form.billing'+ this.countAccordion,
                'id_first_name': 'billing' + this.countAccordion + '-first-name',
                'name_first_name': 'billing' + this.countAccordion + '.[first_name]',
                'id_last_name': 'billing' + this.countAccordion + '-last-name',
                'name_last_name': 'billing' + this.countAccordion + '.[last_name]',
                'id_phone': 'billing' + this.countAccordion + '-phone',
                'name_phone': 'billing' + this.countAccordion + '.[phone]',
                'id_date_shipping': 'billing' + this.countAccordion + '-date-shipping',
                'name_date_shipping': 'billing' + this.countAccordion + '.[date_shipping]',
                'id_time_shipping': 'billing' + this.countAccordion + '-time-shipping',
                'name_time_shipping': 'billing' + this.countAccordion + '.[time_shipping]',
                'id_address': 'billing' + this.countAccordion + '-address',
                'name_address': 'billing' + this.countAccordion + '.[address]',
                'id_city': 'billing' + this.countAccordion + '-city',
                'name_city': 'billing' + this.countAccordion + '.[city]',
                'id_port_code': 'billing' + this.countAccordion + '-port-code',
                'name_port_code': 'billing' + this.countAccordion + '.[port_code]',
                'id_apartment_number': 'billing' + this.countAccordion + '-apartment-number',
                'name_apartment_number': 'billing' + this.countAccordion + '.[apartment_number]',
                'id_deceased_first_name': 'billing' + this.countAccordion + '-deceased-first-name',
                'name_deceased_first_name': 'billing' + this.countAccordion + '.[deceased_first_name]',
                'id_deceased_last_name': 'billing' + this.countAccordion + '-deceased-last-name',
                'name_deceased_last_name': 'billing' + this.countAccordion + '.[deceased_last_name]',
                'id_deceased_date': 'billing' + this.countAccordion + '-deceased-date',
                'name_deceased_date': 'billing' + this.countAccordion + '.[deceased_date]',
                'active': true,
            }
            this.addressArr.push(item);

            this.countAccordion += 1;
        },

        changeValue(model, key, value) 
        {
            this.$set(model, key, value);

            if(key == "date_shipping") {
                this.checkTimeDelivery(moment(value).format('YYYY-MM-DD'));
                this.$set(model, 'date_shipping', moment(value).format('YYYY-MM-DD'));

                if(moment(value).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
                    if(!this.isAddProdButton) {
                        this.$set(model, 'time_shipping', trans('cart::messages.after') + ' ' + this.timeReceiver);
                    }
                    this.$set(model, 'date_note', trans('cart::messages.note_pickup') + ' ' + this.timeReceiver);
                }else {
                    this.$set(model, 'date_note', ''); 
                    if(!this.isAddProdButton) {
                        this.$set(model, 'time_shipping', '');
                    }
                }

                if(model.isDelivery) {
                    if(!model.is_special) {
                        if(!this.timeOptions.includes(model.time_shipping)) {
                            this.$set(model, 'time_shipping', this.timeOptions[0]); 
                        }
                    } else {
                        this.$set(model, 'time_shipping', this.hoursRange[0]);
                    }
                } 
            }
            
            if(key == 'deceased_date') {
                this.$set(model, 'deceased_date', moment(value).format('YYYY-MM-DD'));
                this.$set(model, 'date_shipping', moment(value).format('YYYY-MM-DD'));
           }

            if(model.errors[key]) {
                delete model.errors[key];
            }
        },

        accordion(step) {
            this.step = step;

            if(step == 1) {
                this.disabledOne = false;
                this.disabledTwo = true;
                this.disabledThree = true;
                this.disabledFour = true;

                this.isCheckTwo = false;
                this.isCheckThree = false;
                this.isCheckFour = false;
            }

            if(step == 2) {
                this.disabledTwo = false;
                this.disabledThree = true;
                this.disabledFour = true;

                this.isCheckThree = false;
                this.isCheckFour = false;
            }

            if(step == 3) {
                this.disabledThree = false;
                this.disabledFour = true;
                this.isCheckFour = false;
            }
        },

        chooseProduct(value)
        {
            this.keyItem = value;
            this.selectedProduct = Object.assign({}, this.productOptions[value]);
            this.maxQuantity = this.selectedProduct.qty;
            this.qty = this.selectedProduct.qty;
        },

        updateQtyProduct(item, qty)
        {
            if(qty > this.cart.items[this.keyItem].qty) {
                item.qty = this.cart.items[this.keyItem].qty;
            } else {
                if(qty < 1) {
                    return;
                }
                item.qty = qty;
            }
            this.qty  = parseInt(item.qty);
            this.selectedProduct = item;
        },


        addProduct(item) 
        {
            this.$set(this.disabledDatesMulti, 'customPredictor', function(date) {
                return false
            });

            setTimeout(() => {
                this.initAddress(item.id_address, this.form.multipleAddresses[item.index][item.key]);
            }, 0);

            var existProduct = this.form.multipleAddresses[item.index][item.key].products.filter(i => i.id == this.selectedProduct.id);
            if(existProduct.length > 0) {
                existProduct[0].qty +=  existProduct[0].qty;
                this.formatTotal(existProduct[0]);

                this.form.multipleAddresses[item.index][item.key].products.map(e => {
                    if(e.id == this.selectedProduct.id) {
                        e = existProduct[0];
                    } 
                    return e;
                });

                if(this.productOptions[this.keyItem].qty - existProduct[0].qty > 0) {
                    this.productOptions[this.keyItem].qty -= existProduct[0].qty;
                    this.formatTotal(this.productOptions[this.keyItem]);
                } else {
                    this.productOptions = Object.keys(this.productOptions).reduce((arr, key) => {
                        if(key !== this.keyItem){
                            arr[key] = this.productOptions[key];
                        }
                        return arr;
                    }, {});
                }

            } else {
                this.formatTotal(this.selectedProduct);
                this.form.multipleAddresses[item.index][item.key].products.push(this.selectedProduct);

                if(this.productOptions[this.keyItem].qty - this.selectedProduct.qty > 0) {
                    this.productOptions[this.keyItem].qty -= this.selectedProduct.qty;
                } else {
                    this.productOptions = Object.keys(this.productOptions).reduce((arr, key) => {
                        if(key !== this.keyItem){
                            arr[key] = this.productOptions[key];
                        }
                        return arr;
                    }, {});
                }
            }

            if(this.form.multipleAddresses[item.index][item.key].products.some(product => product.product.is_special)) {
                if(this.form.multipleAddresses[item.index][item.key].isDelivery) {
                    this.$set(this.disabledDatesMulti, 'customPredictor', function(date) {
                        if(moment(date).isoWeekday() == 7){
                        return true
                        }
                    });
                }
                this.maxDate(this.form.multipleAddresses[item.index][item.key], true);


                this.$set(this.form.multipleAddresses[item.index][item.key], 'is_special', true);
                if(this.form.multipleAddresses[item.index][item.key].isDelivery) {
                    this.$set(this.form.multipleAddresses[item.index][item.key], 'time_shipping', this.hoursRange.length > 0 ? this.hoursRange[0]: '');
                }else {
                    this.$set(this.form.multipleAddresses[item.index][item.key], 'time_shipping', '');
                }
            } else {
                this.$set(this.disabledDatesMulti, 'customPredictor', function(date) {
                    return false
                });
                this.maxDate(this.form.multipleAddresses[item.index][item.key], false);

                if(this.form.multipleAddresses[item.index][item.key].isDelivery) {
                    this.$set(this.form.multipleAddresses[item.index][item.key], 'time_shipping', this.timeOptions.length > 0 ? this.timeOptions[0]: '');
                } else {
                    this.$set(this.form.multipleAddresses[item.index][item.key], 'time_shipping', '');
                }
            }
            this.init();
        },


        removeAddress(item) 
        {
            let elem = document.getElementById('confirm-delete-'+item.index);
            elem.classList.remove('show');
            let backdrop = document.getElementsByClassName('modal-backdrop');
            for(var  i = 0; i< backdrop.length; i++ ) {
                backdrop[i].remove();
            }
            if(!this.form.multipleAddresses[item.index][item.key].isDelivery) {
                this.isAddProdButton = true;
            }

            this.costExtra -= this.form.multipleAddresses[item.index][item.key].fee;
            if(this.costExtra <= 0) {
                this.costExtra = 0;
            }

            this.feeMultiAddress = this.costExtra;
            this.updateShippingMethod(this.form.shipping_method);

            this.form.multipleAddresses[item.index][item.key].products.forEach(element => {
                if(this.productOptions[element.id]) {
                    this.productOptions[element.id].qty += element.qty;
                    this.formatTotal(this.productOptions[element.id]);
                } else {
                    this.formatTotal(element);
                    Object.assign(this.productOptions, {
                        [element.id] : element
                    })
                }
            });
           
            this.form.multipleAddresses = this.form.multipleAddresses.filter((e, index) => {
                if(item.index == this.form.multipleAddresses.length) {
                    if(!e[item.key]) { return e;}
                } else {
                    if(!e[item.key]) {
                        if(index > item.index)
                        {
                            e['billing'+ (index-1)] = e['billing'+ index];
                            delete e['billing'+ index];
                        }
                    
                        return e;
                    }
                }
            });

            this.addressArr = this.addressArr.filter((address) => {
                address.active = false;

                if(address.index != item.index) {
                    if(item.index  != this.addressArr.length && address.index > item.index-1) {
                        address.index -= 1;
                        address.data_target = '#confirm-delete-'+address.index;
                        address.modal_id =  'confirm-delete-'+address.index;
                        address.collapse =  'collapse'+address.index;
                        address.collapseTarget =  '#collapse'+address.index;
                        address.key =  'billing' + address.index;
                        address.model =  'form.billing'+ address.index;
                        address.id_first_name =  'billing' + address.index + '-first-name';
                        address.name_first_name =  'billing' + address.index + '.[first_name]';
                        address.id_last_name =  'billing' + address.index + '-last-name';
                        address.name_last_name =  'billing' + address.index + '.[last_name]';
                        address.id_phone =  'billing' + address.index + '-phone';
                        address.name_phone =  'billing' + address.index + '.[phone]';
                        address.id_date_shipping =  'billing' + address.index + '-date-shipping';
                        address.name_date_shipping =  'billing' + address.index + '.[date_shipping]';
                        address.id_time_shipping =  'billing' + address.index + '-time-shipping';
                        address.name_time_shipping =  'billing' + address.index + '.[time_shipping]';
                        address.id_address =  'billing' + address.index + '-address';
                        address.name_address =  'billing' + address.index + '.[address]';
                        address.id_city =  'billing' + address.index + '-city';
                        address.name_city =  'billing' + address.index + '.[city]';
                        address.id_port_code =  'billing' + address.index + '-port-code';
                        address.name_port_code =  'billing' + address.index + '.[port_code]';
                        address.id_apartment_number =  'billing' + address.index + '-apartment-number';
                        address.name_apartment_number =  'billing' + address.index + '.[apartment_number]';
                        address.id_deceased_first_name =  'billing' + address.index + '-deceased-first-name';
                        address.name_deceased_first_name =  'billing' + address.index + '.[deceased_first_name]';
                        address.id_deceased_last_name =  'billing' + address.index + '-deceased-last-name';
                        address.name_deceased_last_name =  'billing' + address.index + '.[deceased_last_name]';
                        address.id_deceased_date =  'billing' + address.index + '-deceased-date';
                        address.name_deceased_date =  'billing' + address.index + '.[deceased_date]';
                        address.active = false;
                    }
                    
                    return address;
                }
            });

            this.countAccordion -= 1;

            this.init();
        },

        formatTotal(product){
            var amount = product.qty * product.product.selling_price.amount;
            var amountFormatted = new Intl.NumberFormat('sv', {
                style: 'currency',
                currency: 'SEK'
            }).format(amount);

            product.total.amount = amount;
            product.total.formatted = amountFormatted;
            product.total.inCurrentCurrency.amount = amount;
            product.total.inCurrentCurrency.formatted = amountFormatted;
        },

        removeProduct(item, product) {
            var products = this.form.multipleAddresses[item.index][item.key].products.filter(e => e.id !== product.id);

            if(products.includes(item => item.product.is_special)) {
                this.$set(this.disabledDates, 'customPredictor', function(date) {
                    if(moment(date).isoWeekday() == 7){
                    return true
                    }
                });
            } else {
                this.$set(this.disabledDates, 'customPredictor', function(date) {
                    return false
                });

                 this.$set(this.form.multipleAddresses[item.index][item.key], 'is_special', false);
            }

            this.$set(this.form.multipleAddresses[item.index][item.key], 'products', products);

            var existProduct = this.productOptions[product.id];
            if(existProduct) {
                this.productOptions[product.id].qty += product.qty;
            } else {
                this.productOptions[product.id] = product;
            }

            this.init();
        },

        checkValidationForm(model, keys) {
            keys.forEach(e => {
                if(!model[e]) {
                    this.$set(model.errors, e, trans('cart::validation.this_field_is_required'));
                } else {
                    if(model.errors[e]) {
                        delete model.errors[e];
                    }
                }
            });
        },

        next(step) {
            if(step == 2) {
                if((this.form.shop_as == 'login' && this.customerEmail) || this.form.shop_as == 'guest' && this.form.customer_email && this.form.customer_first_name && this.form.customer_last_name && this.form.customer_phone) {
                    document.getElementById("collapseOne").classList.remove("show");
                    document.getElementById("accordion-button-one").classList.add("collapsed");
    
                    this.disabledTwo = false;
                    this.step = step;
                    this.isCheckOne = true;
                } else {
                    this.$notify(trans('core::messages.the_given_data_was_invalid'));
                    return;
                }
            } else {
                this.disabledTwo = true;
            }

            if(step == 3) {
                $(document).ready(function(){
                    $(window).scrollTop(0);
                });
                if(this.form.shipping_method == 'free_shipping' ) {
                    var keys = [];
                    if(this.form.is_special) {
                        keys = ['date_shipping'];
                    } else {
                        keys = [];
                    }
        
                    this.checkValidationForm(this.form.billing, keys);

                    if(Object.keys(this.form.billing.errors).length > 0) {
                        this.isCheckTwo = false;
                        this.disabledTwo = false;
                        this.disabledThree = true;
                        this.step = 2;
                        this.$notify(trans('core::messages.the_given_data_was_invalid'));
                        return;
                    } else {
                        this.isCheckTwo = true;
                        this.step = step;
                        this.disabledTwo = false;
                        this.disabledThree = false;
                    }
                } else {
                    if(this.form.delivery_type == 1) {
                        var keys = [];
                        if(this.form.is_special) {
                            keys = ['deceased_first_name', 'deceased_last_name', 'deceased_date', 'time_shipping', 'address', 'city'];
                        } else {
                            keys = ['first_name', 'last_name', 'phone', 'time_shipping', 'address', 'city'];
                        }

                        this.checkValidationForm(this.form.billing, keys);

                        if(Object.keys(this.form.billing.errors).length > 0) {
                            this.isCheckTwo = false;
                            this.disabledTwo = false;
                            this.disabledThree = true;
                            this.step = 2;
                            this.$notify(trans('core::messages.the_given_data_was_invalid'));
                            return;
                        } else {
                            this.isCheckTwo = true;
                            this.step = step;
                            this.disabledTwo = false;
                            this.disabledThree = false;
                        }
                    } else {
                        if(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)].isDelivery) {
                            if(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)].is_special) {
                                keys = ['deceased_first_name', 'deceased_last_name', 'deceased_date', 'time_shipping', 'address', 'city'];
                            } else {
                                keys = ['first_name', 'last_name', 'phone', 'time_shipping', 'address', 'city'];
                            }
                        } else {
                            if(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)].is_special) {
                                keys = ['date_shipping'];
                            } else {
                                keys = [];
                            }
                        }

                        this.checkValidationForm(this.form.multipleAddresses[this.countAccordion - 1]['billing'+(this.countAccordion - 1)], keys);
                                                
                        var errors = this.form.multipleAddresses.filter((item,index) => {
                            if(Object.keys(item['billing'+index].errors).length > 0) {
                                return item;
                            }
                        });

                        if(Object.keys(this.productOptions).length > 0 || errors.length > 0) {
                            this.isCheckTwo = false;
                            this.disabledTwo = false;
                            this.disabledThree = true;
                            this.step = 2;
                            this.$notify(trans('core::messages.the_given_data_was_invalid'));
                            return;
                        } else {
                            this.isCheckTwo = true;
                            this.step = step;
                            this.disabledTwo = false;
                            this.disabledThree = false;
                        }
                    }
                }
            }

            if(step == 4) {
                $(document).ready(function(){
                    $(window).scrollTop(0);
                });
                this.disabledTwo = false;
                this.disabledFour = false;
                this.isCheckThree = true;
                this.step = step;
            }
        },

        chargeShippingCode(model) {
            model.errorAddress = '';
            if (!model.address_lat && !model.address_lng) {
                model.errors.errorAddress = trans('nya::checkout.error_address');
                return;
            }

            var glatlng1 = new google.maps.LatLng(parseFloat(this.shippingByDistance.address_lat), parseFloat(this.shippingByDistance.address_lng));
            var glatlng2 = new google.maps.LatLng(model.address_lat, model.address_lng);
            var kmdistance = parseFloat((google.maps.geometry.spherical.computeDistanceBetween(glatlng1, glatlng2) / 1000).toFixed(2));
            if(kmdistance > this.deliveryLimit) {
                this.$set(model.errors, 'errorAddress', trans('nya::checkout.km_error_address'));
                return;
            }

            if (kmdistance <= parseFloat(this.shippingByDistance.distance_with_city_center)) {
                this.form.costExtraShippingDistance = 0;
            } else {
                this.form.costExtraShippingDistance = Math.round(parseFloat((kmdistance - parseFloat(this.shippingByDistance.distance_with_city_center)) * parseFloat(this.shippingByDistance.cost_in_outside_city_center)));
            }

            this.form.costShippingByDistance = Math.round(parseFloat(this.shippingByDistance.cost_in_inside_city_center) + parseInt(this.form.costExtraShippingDistance));

            if(this.form.delivery_type == 1) {
                this.costExtra = this.form.costExtraShippingDistance;
                model.fee = this.form.costShippingByDistance;
                model.feeFormatted = new Intl.NumberFormat('sv', {
                    style: 'currency',
                    currency: 'SEK'
                }).format(Math.round(model.fee));
                model.feeFormatted = model.feeFormatted.replace(',00', '');
            } else {
                this.costExtra = 0;
                model.fee = this.form.costShippingByDistance;
                model.feeFormatted = new Intl.NumberFormat('sv', {
                    style: 'currency',
                    currency: 'SEK'
                }).format(Math.round(model.fee));
                 model.feeFormatted = model.feeFormatted.replace(',00', '');

                 for(var i = 0; i < this.form.multipleAddresses.length; i++) {
                    this.costExtra += this.form.multipleAddresses[i]['billing'+i]['fee'];
                 }
    
                this.costExtra -= (this.shippingByDistance.cost_in_inside_city_center);
                this.feeMultiAddress = this.costExtra;

            }

            this.showFrom =  false;
            this.updateFreeAfterChangeAddress(this.form.shipping_method);
        },

        changeBillingCity(city) {
            this.$set(this.form.billing, 'city', city);
        },

        changeBillingAddress(model, event) {
            this.$set(model, 'address_lng', '');
            this.$set(model, 'address_lat', '');
            this.$set(model, 'address', '');
            this.$set(model.errors, 'errorAddress', trans('nya::checkout.error_address'));
        },

        changeShippingCity(city) {
            this.$set(this.form.shipping, 'city', city);
        },

        changeShippingMethod(shippingMethod) {
            this.isDelivery = false;
            this.$set(this.disabledDates, 'customPredictor', function(date) {
                return false
            });

            if(shippingMethod.name == 'delivery') {
                this.checkTimeDelivery(this.date);

                if(!this.isSpecial) {
                    this.$set(this.form.billing, 'time_shipping', this.timeOptions[0]);
                } else {
                    this.$set(this.form.billing, 'time_shipping', this.hoursRange[0]);
                }

                if(this.form.delivery_type != 2) {
                    this.$set(this.form, 'delivery_type', 1);
                }

                this.isDelivery = true;
                this.showGateway = 'payson',
                this.$set(this.form, 'payment_method', 'payson');
                // if(1 <= moment().isoWeekday() <= 5) {
                //     this.hoursRange = [8,9,18,19,20,21];
                // } else {
                //     this.hoursRange = [15,19];
                // }

                if(this.form.delivery_type == 1) {
                    if(this.isSpecial) {
                        this.$set(this.disabledDates, 'customPredictor', function(date) {
                            if(moment(date).isoWeekday() == 7){
                            return true
                            }
                        });
                    } else {
                        this.$set(this.disabledDates, 'customPredictor', function(date) {
                            return false
                        });
                    }

                    setTimeout(() => {
                        this.initAddress('billing-address', this.form.billing);
                    }, 0);
                }

                google.maps.event.addDomListener(window, 'load', this.initialize);

            } else {
                this.showGateway = 'pay_at_the_store',
                this.$set(this.form, 'delivery_type', 0);
                this.$set(this.form, 'payment_method', 'pay_at_the_store');

                if(this.form.billing.date_shipping == moment().format('YYYY-MM-DD')) {
                    this.$set(this.form.billing, 'time_shipping', trans('cart::messages.after') + ' ' + this.timeReceiver);
                    this.$set(this.form.billing, 'date_note', trans('cart::messages.note_pickup') + ' ' + this.timeReceiver);
                } else {
                    this.$set(this.form.billing, 'time_shipping', '');
                    this.$set(this.form.billing, 'date_note', '');
                }
            }
            this.$set(this.form, 'shipping_method', shippingMethod.name);
        },

        initAddress(addressId, model) {
            var input = document.getElementById(addressId);
            if(input) {
                var autocomplete = new google.maps.places.Autocomplete(input);
                google.maps.event.addListener(autocomplete, 'place_changed', () => {
                    var place = autocomplete.getPlace();
                    this.$set(model, 'address_lat', place.geometry.location.lat());
                    this.$set(model, 'address_lng', place.geometry.location.lng());
                    this.$set(model, 'address', document.getElementById(addressId).value);

                     if(model.errors.address) {
                        delete model.errors.address;
                    }

                    if (!model.address_lat && !model.address_lng) {
                        this.$set(model.errors, 'errorAddress', trans('nya::checkout.error_address'));
                    } else {
                        delete model.errors.errorAddress;
                    }

                    this.chargeShippingCode(model);
                    
                    let matches = place.address_components.filter(address_component =>
                ["locality", "colloquial_area", "postal_town"].some(word => ~address_component.types.indexOf(word)));
                    this.$set(model, 'city', matches.length > 0 ? matches[0].short_name : '');
                    if(model.city){
                        if(model.errors.city) {
                            delete model.errors.city;
                        }
                    } else {
                        this.$set(model.errors, 'city', trans('cart::validation.this_field_is_required'));
                    }
                });
            }
        },

        addTaxes() {
            this.loadingOrderSummary = true;
            this.$set(this.form, 'costExtra', this.costExtra);

            $.ajax({
                method: 'POST',
                url: route('cart.taxes.store'),
                data: this.form,
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        showFormAuth(name) {
            this.showAuth = name;

            if(name == 'login') {
             this.$set(this.form, 'shop_as', 'login');
            }

            if(name == 'guest') {
                this.$set(this.form, 'shop_as', 'guest');
            }

            if(name == 'register') {
                var script = document.createElement('script');
                script.src = "https://nya-ljusekulla.modoro.work/themes/nya/public/js/flatpickr.js?v=6232bf401a56a";
                document.getElementsByTagName('head')[0].appendChild(script);
            }

            const now = new Date();
            const item = {
                value: name,
                expirationDate: new Date(now.getTime() + 300000),
            }
            window.sessionStorage.setItem('form-auth', JSON.stringify(item));
        },

        sessionGet(key) {
            let stringValue = window.sessionStorage.getItem(key)
              if (stringValue !== null) {
                let value = JSON.parse(stringValue)
                  let expirationDate = new Date(value.expirationDate)
                  if (expirationDate > new Date()) {
                    return value.value
                  } else {
                    window.sessionStorage.removeItem(key)
                  }
              }
              return null
        },

        showFormGateway(name) {
            this.showGateway = name;
        },

        showDeliveryForm(type) {
            this.$set(this.form, 'delivery_type', type);
            if(type == 2) {
                if(this.addressArr.length == 0) {
                    this.addAddress();
                } else {
                    setTimeout(() => {
                        this.initAddress('billing'+(this.countAccordion-1)+'-address',  this.form.multipleAddresses[this.countAccordion-1]['billing'+(this.countAccordion - 1)]);
                    }, 0);
                }
                this.costExtra = this.feeMultiAddress;
            } else {
                this.costExtra = this.form.billing.fee;
                setTimeout(() => {
                    this.initAddress('billing-address', this.form.billing);
                }, 0);
            }

            this.updateShippingMethod(this.form.shipping_method);
        },

        placeOrder() {
            if (!this.form.terms_and_conditions || this.placingOrder) {
                this.$notify(trans('core::messages.the_given_data_was_invalid'));
                return;
            }

            this.placingOrder = true;

            $.ajax({
                method: 'POST',
                url: route('checkout.create'),
                data: this.form,
            }).then((response) => {
                if(this.form.payment_method == 'payson') {
                    if(response['payson']['snippet']) {
                        this.showModal = true;
                        this.placingOrder = false;

                        this.hiddenCheckout = false;
                        this.checkoutUrl = response['payson']['snippet'];
        
                        var script = document.createElement('script');
                        script.src = "https://test-www.payson.se/embedded/Content/payson.js?v2";
                        document.getElementsByTagName('head')[0].appendChild(script);
                    } else {
                     this.$notify(response['payson']['message']);
                     this.placingOrder = false;
                    }
                } else {
                    window.location.href = route('checkout.complete.show');
                }
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                    if(!this.errors.has('customer_email')) {
                        this.isCheckOne = true;
                    } else {
                        this.isCheckOne = false;
                    }

                    if(this.form.shipping_method == 'free_shipping' ) {
                        this.isCheckTwo = true;
                    } else {
                        this.isCheckTwo = false;
                    }

                    if(this.form.shipping_method == 'delivey' 
                    && !this.errors.has('billing.address_1')
                    && !this.errors.has('billing.city')
                    && !this.errors.has('billing.first_name')
                    && !this.errors.has('billing.last_name')
                    && !this.errors.has('billing.phone')
                    && !this.errors.has('billing.zip'
                    && !this.form.billing.errorAddress
                    )
                    ) {
                        this.isCheckTwo = true;
                    }else {
                        this.isCheckTwo = false;
                    }
                    this.isCheckThree = true;
                    this.isCheckFour = true;
                }

                this.$notify(xhr.responseJSON.message);

                this.placingOrder = false;
            });
        },
    },
};
